import React from 'react';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import MagicForm from '../../../../../Components/Form/MagicForm';
import { SelectValue } from '../../../../../Components/Base/Select/Select';

export interface MedicalRequestPolandFormValues {
	requestType: SelectValue;
	medicalFacility: SelectValue;
	procedure?: SelectValue;
	primaryDiagnose: SelectValue;
	secondaryDiagnoses?: { item: SelectValue | undefined }[];
	note?: string;
}

interface Props {
	patientId: string;
	doctorIdentificationNumber?: string;
	onSubmit: (values: MedicalRequestPolandFormValues) => void;
}

const formScheme: ItemScheme[] = [
	{
		type: MagicField.P1_MEDICAL_REQUEST_TYPE,
		key: 'requestType',
		title: 'component.medicalRequestPolandForm.requestType',
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.P1_MEDICAL_FACILITY,
		key: 'medicalFacility',
		title: 'component.medicalRequestPolandForm.medicalFacility',
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.P1_DISEASES,
		key: 'primaryDiagnose',
		title: 'component.medicalRequestPolandForm.primaryDiagnose',
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.MULTIPLIER,
		key: 'secondaryDiagnoses',
		children: [
			{
				type: MagicField.P1_DISEASES,
				title: 'component.medicalRequestPolandForm.secondaryDiagnose',
				key: 'item',
			},
			{
				type: MagicField.MULTIPLIER_REMOVE_BUTTON,
			},
		],
		settings: {
			createDefault: 1,
		},
	},
	{
		type: MagicField.P1_PROCEDURES,
		key: 'procedure',
		title: 'component.medicalRequestPolandForm.procedure',
		settings: {
			errorMessage: 'validation.medicalRequestPolandForm.procedureOrNote',
			requiredRules: [
				{
					formControlKey: 'procedure',
					rule: 'notEqual',
					value: '__never__',
					groupKeys: ['procedure', 'note'],
				},
			],
			required: false,
		},
	},
	{
		type: MagicField.TEXTAREA,
		key: 'note',
		title: 'component.medicalRequestPolandForm.note',
	},
];

const MedicalRequestPolandForm: React.FC<Props> = ({ onSubmit }) => {
	const handleSubmit = (values: MedicalRequestPolandFormValues) => {
		onSubmit(values);
	};

	return <MagicForm formScheme={formScheme} onSubmit={handleSubmit} />;
};

export default MedicalRequestPolandForm;
